// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_bilateral_trade_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionStatus } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { TradingContractStatus } from "../../bfftypes/v1/trading_contract_status_pb";
import { file_bfftypes_v1_trading_contract_status } from "../../bfftypes/v1/trading_contract_status_pb";
import type { TradingDeliveryType } from "../../bfftypes/v1/trading_delivery_type_pb";
import { file_bfftypes_v1_trading_delivery_type } from "../../bfftypes/v1/trading_delivery_type_pb";
import type { TradingExecutionRoute } from "../../bfftypes/v1/trading_execution_route_pb";
import { file_bfftypes_v1_trading_execution_route } from "../../bfftypes/v1/trading_execution_route_pb";
import type { TradingSpreadKind } from "../../bfftypes/v1/trading_spread_kind_pb";
import { file_bfftypes_v1_trading_spread_kind } from "../../bfftypes/v1/trading_spread_kind_pb";
import type { TradingTimeZoneType } from "../../bfftypes/v1/trading_time_zone_type_pb";
import { file_bfftypes_v1_trading_time_zone_type } from "../../bfftypes/v1/trading_time_zone_type_pb";
import type { BilateralTrade, BilateralTradeCsvRowResult, BilateralTradeImportStaleness, BilateralTradeInput, BilateralTradeListItem, BilateralTradeMonthlyGroup, BilateralTradeRecap, BilateralTradeSummary, DeliveryCalendarDay, ESLSyncStatus, ExportBilateralTradesRow } from "./supply_bilateral_trade_model_pb";
import { file_bffuser_v1_supply_bilateral_trade_model } from "./supply_bilateral_trade_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_bilateral_trade_service.proto.
 */
export const file_bffuser_v1_supply_bilateral_trade_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bfftypes_v1_side, file_bfftypes_v1_trading_contract_status, file_bfftypes_v1_trading_delivery_type, file_bfftypes_v1_trading_execution_route, file_bfftypes_v1_trading_spread_kind, file_bfftypes_v1_trading_time_zone_type, file_bffuser_v1_supply_bilateral_trade_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListBilateralTradesRequest
 */
export type ListBilateralTradesRequest = Message<"bffuser.v1.ListBilateralTradesRequest"> & {
  /**
   * 売買区分フィルタ。未指定 (UNSPECIFIED) の場合は絞り込みなし。
   *
   * @generated from field: optional bfftypes.v1.Side buy_sell_filter = 1;
   */
  buySellFilter?: Side;

  /**
   * 取引経路フィルタ。未指定の場合は絞り込みなし。
   *
   * @generated from field: optional bfftypes.v1.TradingExecutionRoute execution_route_filter = 2;
   */
  executionRouteFilter?: TradingExecutionRoute;

  /**
   * タイムゾーン区分フィルタ (AC-SBL-047、issue #6698)。フィールド自体を
   * 送らない (unset) 場合は絞り込みなし。**フィールドあり + UNSPECIFIED =
   * カスタム時間帯のみを抽出**（単票 BilateralTrade.time_zone_type の
   * UNSPECIFIED=カスタム時間帯と同じ意味論。optional 修飾による proto3 の
   * explicit presence を利用し、「絞り込みなし」と区別する）。
   * BASE/PEAK/OFF_PEAK のいずれかを指定した場合は、契約の実際の
   * 受渡パターンがその値の分類結果 (backend supplyentity.ClassifyTradingBand)
   * と一致する行を残す — カスタム時間帯 (custom_bands) 登録でも中身が完全
   * 一致すれば該当する。
   *
   * @generated from field: optional bfftypes.v1.TradingTimeZoneType time_zone_type_filter = 3;
   */
  timeZoneTypeFilter?: TradingTimeZoneType;

  /**
   * 受渡区分フィルタ。 旧 delivery_type_id (UUID) から enum に変更。
   * 未指定 (UNSPECIFIED) の場合は絞り込みなし。
   *
   * @generated from field: optional bfftypes.v1.TradingDeliveryType delivery_type_filter = 4;
   */
  deliveryTypeFilter?: TradingDeliveryType;

  /**
   * エリアコードフィルタ。未指定の場合は絞り込みなし。
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code_filter = 5;
   */
  areaCodeFilter?: AreaCode;

  /**
   * 相対先名称フィルタ (完全一致)。未指定の場合は絞り込みなし。
   * 選択肢は ListBilateralTradesResponse.counterparty_options を使う
   * (AC-SBL-024: 取引先以外のフィルタ一致全件から Distinct 動的生成)。
   *
   * @generated from field: optional string partner_name_filter = 6;
   */
  partnerNameFilter?: string;

  /**
   * 受渡期間の絞り込み開始日。AC-023: 期間重複判定。
   *
   * @generated from field: optional google.type.Date delivery_period_from = 7;
   */
  deliveryPeriodFrom?: Date;

  /**
   * 受渡期間の絞り込み終了日。AC-023: 期間重複判定。
   *
   * @generated from field: optional google.type.Date delivery_period_to = 8;
   */
  deliveryPeriodTo?: Date;

  /**
   * true の場合、monthly_groups を返す (月別グループ表示モード)。
   * false の場合、items のみを返す。
   *
   * @generated from field: bool monthly_grouping = 9;
   */
  monthlyGrouping: boolean;

  /**
   * ページ番号 (1 起算)。
   *
   * @generated from field: int32 page = 10;
   */
  page: number;

  /**
   * ページサイズ。既定 50、最大 500。
   *
   * @generated from field: int32 page_size = 11;
   */
  pageSize: number;

  /**
   * ステータスフィルタ。未指定 (UNSPECIFIED) の場合は絞り込みなし。
   * プロトタイプ「ステータス: 進行中 / 取消 / すべて」 で
   * 進行中 = ACTIVE、 取消 = CANCELLED、 すべて = UNSPECIFIED を選ぶ運用。
   *
   * @generated from field: optional bfftypes.v1.TradingContractStatus status_filter = 12;
   */
  statusFilter?: TradingContractStatus;

  /**
   * スプレッド種別フィルタ。未指定の場合は絞り込みなし。
   *
   * @generated from field: optional bfftypes.v1.TradingSpreadKind spread_kind_filter = 13;
   */
  spreadKindFilter?: TradingSpreadKind;

  /**
   * 期間満了表示。 false (既定) の場合、 status=EXPIRED の契約を返り値から除外する。
   * true の場合、 status=EXPIRED も含めて返す。
   *
   * @generated from field: bool include_expired = 14;
   */
  includeExpired: boolean;
};

/**
 * Describes the message bffuser.v1.ListBilateralTradesRequest.
 * Use `create(ListBilateralTradesRequestSchema)` to create a new message.
 */
export const ListBilateralTradesRequestSchema: GenMessage<ListBilateralTradesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 0);

/**
 * @generated from message bffuser.v1.ListBilateralTradesResponse
 */
export type ListBilateralTradesResponse = Message<"bffuser.v1.ListBilateralTradesResponse"> & {
  /**
   * フィルタ一致かつ現ページの取引一覧。monthly_grouping=true の場合は空。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeListItem items = 1;
   */
  items: BilateralTradeListItem[];

  /**
   * フィルタ一致全件の集計サマリ。
   *
   * @generated from field: bffuser.v1.BilateralTradeSummary summary = 2;
   */
  summary?: BilateralTradeSummary;

  /**
   * 月別グループ。monthly_grouping=false の場合は空。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeMonthlyGroup monthly_groups = 3;
   */
  monthlyGroups: BilateralTradeMonthlyGroup[];

  /**
   * フィルタ一致件数合計。ページネーション用。
   *
   * @generated from field: int32 total_count = 4;
   */
  totalCount: number;

  /**
   * Deprecated: backend は値を設定しない (常に UNSPECIFIED)。import_staleness を使う。
   *
   * @generated from field: bffuser.v1.ESLSyncStatus esl_sync_status = 5 [deprecated = true];
   * @deprecated
   */
  eslSyncStatus: ESLSyncStatus;

  /**
   * 取引先フィルタの選択肢 (AC-SBL-024)。取引先以外のフィルタ一致全件 (ページ切り出し前) の
   * 相対先名称を出現順で重複排除したもの。フロントエンドは
   * partner_name_filter のドロップダウン候補にこれを使う。
   * Mirrors internalapi.v1.ListBilateralTradesResponse.counterparty_options.
   *
   * @generated from field: repeated string counterparty_options = 6;
   */
  counterpartyOptions: string[];

  /**
   * 取り込み (外部連携) の途絶状態 (AC-SBL-016)。
   * Mirrors internalapi.v1.ListBilateralTradesResponse.import_staleness.
   *
   * @generated from field: bffuser.v1.BilateralTradeImportStaleness import_staleness = 7;
   */
  importStaleness?: BilateralTradeImportStaleness;
};

/**
 * Describes the message bffuser.v1.ListBilateralTradesResponse.
 * Use `create(ListBilateralTradesResponseSchema)` to create a new message.
 */
export const ListBilateralTradesResponseSchema: GenMessage<ListBilateralTradesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 1);

/**
 * @generated from message bffuser.v1.GetBilateralTradeRequest
 */
export type GetBilateralTradeRequest = Message<"bffuser.v1.GetBilateralTradeRequest"> & {
  /**
   * 取得対象の取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBilateralTradeRequest.
 * Use `create(GetBilateralTradeRequestSchema)` to create a new message.
 */
export const GetBilateralTradeRequestSchema: GenMessage<GetBilateralTradeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 2);

/**
 * @generated from message bffuser.v1.GetBilateralTradeRecapRequest
 */
export type GetBilateralTradeRecapRequest = Message<"bffuser.v1.GetBilateralTradeRecapRequest"> & {
  /**
   * 取得対象の取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBilateralTradeRecapRequest.
 * Use `create(GetBilateralTradeRecapRequestSchema)` to create a new message.
 */
export const GetBilateralTradeRecapRequestSchema: GenMessage<GetBilateralTradeRecapRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 3);

/**
 * @generated from message bffuser.v1.GetBilateralTradeRecapResponse
 */
export type GetBilateralTradeRecapResponse = Message<"bffuser.v1.GetBilateralTradeRecapResponse"> & {
  /**
   * 取引の Recap 詳細情報。
   *
   * @generated from field: bffuser.v1.BilateralTradeRecap recap = 1;
   */
  recap?: BilateralTradeRecap;
};

/**
 * Describes the message bffuser.v1.GetBilateralTradeRecapResponse.
 * Use `create(GetBilateralTradeRecapResponseSchema)` to create a new message.
 */
export const GetBilateralTradeRecapResponseSchema: GenMessage<GetBilateralTradeRecapResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 4);

/**
 * @generated from message bffuser.v1.DeleteBilateralTradeRequest
 */
export type DeleteBilateralTradeRequest = Message<"bffuser.v1.DeleteBilateralTradeRequest"> & {
  /**
   * 削除対象の取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観的排他制御用タイムスタンプ。list response の updated_at を
   * proto Timestamp のまま round-trip すること。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteBilateralTradeRequest.
 * Use `create(DeleteBilateralTradeRequestSchema)` to create a new message.
 */
export const DeleteBilateralTradeRequestSchema: GenMessage<DeleteBilateralTradeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 5);

/**
 * DeleteBilateralTradeResponse is intentionally empty to allow future
 * extension without a breaking change.
 *
 * @generated from message bffuser.v1.DeleteBilateralTradeResponse
 */
export type DeleteBilateralTradeResponse = Message<"bffuser.v1.DeleteBilateralTradeResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBilateralTradeResponse.
 * Use `create(DeleteBilateralTradeResponseSchema)` to create a new message.
 */
export const DeleteBilateralTradeResponseSchema: GenMessage<DeleteBilateralTradeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 6);

/**
 * @generated from message bffuser.v1.CreateBilateralTradeRequest
 */
export type CreateBilateralTradeRequest = Message<"bffuser.v1.CreateBilateralTradeRequest"> & {
  /**
   * 登録する相対取引の入力内容。
   *
   * @generated from field: bffuser.v1.BilateralTradeInput input = 1;
   */
  input?: BilateralTradeInput;
};

/**
 * Describes the message bffuser.v1.CreateBilateralTradeRequest.
 * Use `create(CreateBilateralTradeRequestSchema)` to create a new message.
 */
export const CreateBilateralTradeRequestSchema: GenMessage<CreateBilateralTradeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 7);

/**
 * @generated from message bffuser.v1.CreateBilateralTradeResponse
 */
export type CreateBilateralTradeResponse = Message<"bffuser.v1.CreateBilateralTradeResponse"> & {
  /**
   * 登録された相対取引の full 情報。
   *
   * @generated from field: bffuser.v1.BilateralTrade trade = 1;
   */
  trade?: BilateralTrade;
};

/**
 * Describes the message bffuser.v1.CreateBilateralTradeResponse.
 * Use `create(CreateBilateralTradeResponseSchema)` to create a new message.
 */
export const CreateBilateralTradeResponseSchema: GenMessage<CreateBilateralTradeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 8);

/**
 * @generated from message bffuser.v1.UpdateBilateralTradeRequest
 */
export type UpdateBilateralTradeRequest = Message<"bffuser.v1.UpdateBilateralTradeRequest"> & {
  /**
   * 更新対象の取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観的排他制御用タイムスタンプ。GetBilateralTrade response の updated_at を
   * proto Timestamp のまま round-trip すること。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 更新する相対取引の入力内容。
   *
   * @generated from field: bffuser.v1.BilateralTradeInput input = 3;
   */
  input?: BilateralTradeInput;
};

/**
 * Describes the message bffuser.v1.UpdateBilateralTradeRequest.
 * Use `create(UpdateBilateralTradeRequestSchema)` to create a new message.
 */
export const UpdateBilateralTradeRequestSchema: GenMessage<UpdateBilateralTradeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 9);

/**
 * @generated from message bffuser.v1.UpdateBilateralTradeResponse
 */
export type UpdateBilateralTradeResponse = Message<"bffuser.v1.UpdateBilateralTradeResponse"> & {
  /**
   * 更新された相対取引の full 情報。
   *
   * @generated from field: bffuser.v1.BilateralTrade trade = 1;
   */
  trade?: BilateralTrade;
};

/**
 * Describes the message bffuser.v1.UpdateBilateralTradeResponse.
 * Use `create(UpdateBilateralTradeResponseSchema)` to create a new message.
 */
export const UpdateBilateralTradeResponseSchema: GenMessage<UpdateBilateralTradeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 10);

/**
 * @generated from message bffuser.v1.GetBilateralTradeResponse
 */
export type GetBilateralTradeResponse = Message<"bffuser.v1.GetBilateralTradeResponse"> & {
  /**
   * 取得した相対取引の full 情報。
   *
   * @generated from field: bffuser.v1.BilateralTrade trade = 1;
   */
  trade?: BilateralTrade;

  /**
   * 受渡期間内の日ごとのカレンダービュー状態 (AC-SBM-007)。
   *
   * @generated from field: repeated bffuser.v1.DeliveryCalendarDay calendar_days = 2;
   */
  calendarDays: DeliveryCalendarDay[];
};

/**
 * Describes the message bffuser.v1.GetBilateralTradeResponse.
 * Use `create(GetBilateralTradeResponseSchema)` to create a new message.
 */
export const GetBilateralTradeResponseSchema: GenMessage<GetBilateralTradeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 11);

/**
 * @generated from message bffuser.v1.CheckBilateralTradeCsvRequest
 */
export type CheckBilateralTradeCsvRequest = Message<"bffuser.v1.CheckBilateralTradeCsvRequest"> & {
  /**
   * CSV ファイルの生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。上限 20 MB
   * (common.md 非機能要件。行数・削除件数の上限は設けない)。
   * acting_member_id は BFF が eauth セッションから補完する。
   *
   * @generated from field: bytes csv_content = 1;
   */
  csvContent: Uint8Array;

  /**
   * 投入 CSV ファイル名 (csv_upload_history.csv_file_name に記録)。任意。
   *
   * @generated from field: optional string csv_file_name = 2;
   */
  csvFileName?: string;
};

/**
 * Describes the message bffuser.v1.CheckBilateralTradeCsvRequest.
 * Use `create(CheckBilateralTradeCsvRequestSchema)` to create a new message.
 */
export const CheckBilateralTradeCsvRequestSchema: GenMessage<CheckBilateralTradeCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 12);

/**
 * @generated from message bffuser.v1.CheckBilateralTradeCsvResponse
 */
export type CheckBilateralTradeCsvResponse = Message<"bffuser.v1.CheckBilateralTradeCsvResponse"> & {
  /**
   * 引換券。ApplyBilateralTradeCsv に渡す。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 行ごとの差分プレビュー (CSV のデータ行順)。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeCsvRowResult rows = 2;
   */
  rows: BilateralTradeCsvRowResult[];

  /**
   * 変更なし行数。
   *
   * @generated from field: int32 unchanged_count = 3;
   */
  unchangedCount: number;

  /**
   * 新規行数。
   *
   * @generated from field: int32 created_count = 4;
   */
  createdCount: number;

  /**
   * 変更行数。
   *
   * @generated from field: int32 updated_count = 5;
   */
  updatedCount: number;

  /**
   * 削除行数。
   *
   * @generated from field: int32 deleted_count = 6;
   */
  deletedCount: number;

  /**
   * エラー行数。> 0 なら確定 API は全体拒否される。
   *
   * @generated from field: int32 error_count = 7;
   */
  errorCount: number;

  /**
   * Check 実行時点で、入稿済みデータの全量ダウンロード対象と同一集合に入る
   * 既存契約の件数 (CSV の delete=1 が実際に受理する集合より狭い)
   * (= 誤削除防止の警告バナー「既存取引の 50% 超を削除」spec AC-DUB-030 の分母)。
   * 母集団の定義と根拠は backend の TradingContractRepository.CountDeletableTrades
   * の godoc を参照。
   *
   * @generated from field: int32 deletable_trade_count = 11;
   */
  deletableTradeCount: number;

  /**
   * delete=1 の取引のうち、提出済み（または提出処理中の）計画に含まれる
   * 受渡日を持つ取引の件数（spec AC-DUB-060 の {該当件数}）。0 は該当なし
   * (= Step2 警告バナー・確定ダイアログの追記文言を出さない)。
   *
   * @generated from field: int32 delivery_plan_warning_count = 12;
   */
  deliveryPlanWarningCount: number;

  /**
   * delivery_plan_warning_count の対象取引ID一覧 (CSV のデータ行順)。
   *
   * @generated from field: repeated string delivery_plan_warning_trade_ids = 13 [deprecated = true];
   * @deprecated
   */
  deliveryPlanWarningTradeIds: string[];

  /**
   * 対象の取引・受渡日と、その日に影響する計画の現在の提出ステータス。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeDeliveryPlanWarning delivery_plan_warnings = 14;
   */
  deliveryPlanWarnings: BilateralTradeDeliveryPlanWarning[];
};

/**
 * Describes the message bffuser.v1.CheckBilateralTradeCsvResponse.
 * Use `create(CheckBilateralTradeCsvResponseSchema)` to create a new message.
 */
export const CheckBilateralTradeCsvResponseSchema: GenMessage<CheckBilateralTradeCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 13);

/**
 * @generated from message bffuser.v1.BilateralTradeDeliveryPlanWarning
 */
export type BilateralTradeDeliveryPlanWarning = Message<"bffuser.v1.BilateralTradeDeliveryPlanWarning"> & {
  /**
   * @generated from field: string trade_id = 1;
   */
  tradeId: string;

  /**
   * @generated from field: google.type.Date delivery_date = 2;
   */
  deliveryDate?: Date;

  /**
   * @generated from field: repeated bfftypes.v1.PlanSubmissionStatus statuses = 3;
   */
  statuses: PlanSubmissionStatus[];
};

/**
 * Describes the message bffuser.v1.BilateralTradeDeliveryPlanWarning.
 * Use `create(BilateralTradeDeliveryPlanWarningSchema)` to create a new message.
 */
export const BilateralTradeDeliveryPlanWarningSchema: GenMessage<BilateralTradeDeliveryPlanWarning> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 14);

/**
 * @generated from message bffuser.v1.ApplyBilateralTradeCsvRequest
 */
export type ApplyBilateralTradeCsvRequest = Message<"bffuser.v1.ApplyBilateralTradeCsvRequest"> & {
  /**
   * CheckBilateralTradeCsvResponse.check_token。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;
};

/**
 * Describes the message bffuser.v1.ApplyBilateralTradeCsvRequest.
 * Use `create(ApplyBilateralTradeCsvRequestSchema)` to create a new message.
 */
export const ApplyBilateralTradeCsvRequestSchema: GenMessage<ApplyBilateralTradeCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 15);

/**
 * @generated from message bffuser.v1.ApplyBilateralTradeCsvResponse
 */
export type ApplyBilateralTradeCsvResponse = Message<"bffuser.v1.ApplyBilateralTradeCsvResponse"> & {
  /**
   * 実際に作成した契約数。
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * 実際に更新した契約数。
   *
   * @generated from field: int32 updated_count = 2;
   */
  updatedCount: number;

  /**
   * 実際に論理削除した契約数。
   *
   * @generated from field: int32 deleted_count = 3;
   */
  deletedCount: number;
};

/**
 * Describes the message bffuser.v1.ApplyBilateralTradeCsvResponse.
 * Use `create(ApplyBilateralTradeCsvResponseSchema)` to create a new message.
 */
export const ApplyBilateralTradeCsvResponseSchema: GenMessage<ApplyBilateralTradeCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 16);

/**
 * 絞り込み条件を持たない (= 全件エクスポートが本 RPC の契約、AC-DUC-029)。
 *
 * @generated from message bffuser.v1.ExportBilateralTradesRequest
 */
export type ExportBilateralTradesRequest = Message<"bffuser.v1.ExportBilateralTradesRequest"> & {
  /**
   * 区分値のセルを出す言語。frontend が表示言語を渡す (UNSPECIFIED は日本語)。
   *
   * @generated from field: bffuser.v1.BilateralTradeCsvLanguage language = 1;
   */
  language: BilateralTradeCsvLanguage;
};

/**
 * Describes the message bffuser.v1.ExportBilateralTradesRequest.
 * Use `create(ExportBilateralTradesRequestSchema)` to create a new message.
 */
export const ExportBilateralTradesRequestSchema: GenMessage<ExportBilateralTradesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 17);

/**
 * @generated from message bffuser.v1.ExportBilateralTradesResponse
 */
export type ExportBilateralTradesResponse = Message<"bffuser.v1.ExportBilateralTradesResponse"> & {
  /**
   * 出力対象の全 CSV 行。順序は (取引ID 昇順) で決定的。既存 multi-leg 契約
   * (leg 概念廃止前に登録された 1 契約 N leg のデータ) は同一取引ID の行が
   * 複数出力されうる。
   *
   * @generated from field: repeated bffuser.v1.ExportBilateralTradesRow rows = 1;
   */
  rows: ExportBilateralTradesRow[];

  /**
   * 出力対象の最終更新時刻 (= 全行の updated_at の最大値)。ダウンロード確認
   * モーダルの「基準時点」に表示する (uploads/common.md AC-DUC-032)。
   * 0 件のときは未設定。
   *
   * @generated from field: optional google.protobuf.Timestamp data_updated_at = 2;
   */
  dataUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ExportBilateralTradesResponse.
 * Use `create(ExportBilateralTradesResponseSchema)` to create a new message.
 */
export const ExportBilateralTradesResponseSchema: GenMessage<ExportBilateralTradesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_service, 18);

/**
 * 相対取引契約 CSV の入稿済みデータのダウンロードで、区分値のセルを出す言語
 * (`conventions.md`「CSV の英語表示」、`admin/data/uploads/bilateral-trade.md` §2
 * 「英語表示対応」)。UNSPECIFIED は日本語として扱う (本 field 追加前の呼び出しと同じ出力)。
 * ENGLISH は区分値を英語の値で出し、英語の値が未定義の区分値は日本語のまま出す。
 *
 * @generated from enum bffuser.v1.BilateralTradeCsvLanguage
 */
export enum BilateralTradeCsvLanguage {
  /**
   * @generated from enum value: BILATERAL_TRADE_CSV_LANGUAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILATERAL_TRADE_CSV_LANGUAGE_JAPANESE = 1;
   */
  JAPANESE = 1,

  /**
   * @generated from enum value: BILATERAL_TRADE_CSV_LANGUAGE_ENGLISH = 2;
   */
  ENGLISH = 2,
}

/**
 * Describes the enum bffuser.v1.BilateralTradeCsvLanguage.
 */
export const BilateralTradeCsvLanguageSchema: GenEnum<BilateralTradeCsvLanguage> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_bilateral_trade_service, 0);

/**
 * @generated from service bffuser.v1.SupplyBilateralTradeService
 */
export const SupplyBilateralTradeService: GenService<{
  /**
   * ListBilateralTrades returns all bilateral trades matching the given
   * filters together with aggregated summary, optional monthly grouping,
   * and the eSL sync status.
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ListBilateralTrades
   */
  listBilateralTrades: {
    methodKind: "unary";
    input: typeof ListBilateralTradesRequestSchema;
    output: typeof ListBilateralTradesResponseSchema;
  },
  /**
   * GetBilateralTradeRecap returns the full Recap detail of a single bilateral
   * trade.
   * Separate from ListBilateralTrades because the list intentionally omits
   * unit price, total amount, and supply hours (see parent issue §5).
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.GetBilateralTradeRecap
   */
  getBilateralTradeRecap: {
    methodKind: "unary";
    input: typeof GetBilateralTradeRecapRequestSchema;
    output: typeof GetBilateralTradeRecapResponseSchema;
  },
  /**
   * DeleteBilateralTrade deletes a manually-entered bilateral trade.
   * expected_updated_at enables optimistic locking; the backend returns
   * ABORTED when the row has been modified since the client last fetched it.
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.DeleteBilateralTrade
   */
  deleteBilateralTrade: {
    methodKind: "unary";
    input: typeof DeleteBilateralTradeRequestSchema;
    output: typeof DeleteBilateralTradeResponseSchema;
  },
  /**
   * CreateBilateralTrade registers a new manually-entered bilateral trade.
   * organization_id is resolved from the eauth session (not exposed to frontend).
   * Returns the full BilateralTrade for immediate UI reflection.
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.CreateBilateralTrade
   */
  createBilateralTrade: {
    methodKind: "unary";
    input: typeof CreateBilateralTradeRequestSchema;
    output: typeof CreateBilateralTradeResponseSchema;
  },
  /**
   * UpdateBilateralTrade updates a manually-entered bilateral trade.
   * organization_id is resolved from the eauth session.
   * expected_updated_at enables optimistic locking; the backend returns
   * ABORTED when the row has been modified since the client last fetched it.
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.UpdateBilateralTrade
   */
  updateBilateralTrade: {
    methodKind: "unary";
    input: typeof UpdateBilateralTradeRequestSchema;
    output: typeof UpdateBilateralTradeResponseSchema;
  },
  /**
   * GetBilateralTrade returns the full BilateralTrade for the given id.
   * organization_id is resolved from the eauth session.
   * Used to populate the edit form with all current field values.
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.GetBilateralTrade
   */
  getBilateralTrade: {
    methodKind: "unary";
    input: typeof GetBilateralTradeRequestSchema;
    output: typeof GetBilateralTradeResponseSchema;
  },
  /**
   * CheckBilateralTradeCsv parses and validates the 契約マスタ CSV and returns
   * the 5-state row diff preview plus a check_token (引換券). No persistent
   * side-effect on trading_contract. organization_id / acting_member_id are
   * resolved from the eauth session (not exposed to frontend).
   *
   * 旧 ImportBilateralTrades (all-or-nothing 単発 RPC) を置換した 2 段 API の
   * 前段。Mirrors internalapi.v1 CheckBilateralTradeCsv。
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.CheckBilateralTradeCsv
   */
  checkBilateralTradeCsv: {
    methodKind: "unary";
    input: typeof CheckBilateralTradeCsvRequestSchema;
    output: typeof CheckBilateralTradeCsvResponseSchema;
  },
  /**
   * ApplyBilateralTradeCsv exchanges a valid check_token for the actual
   * 差分 upsert + 48 点再展開 (1 transaction)。エラー行が 1 件でもある
   * check_token は全体拒否される。
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ApplyBilateralTradeCsv
   */
  applyBilateralTradeCsv: {
    methodKind: "unary";
    input: typeof ApplyBilateralTradeCsvRequestSchema;
    output: typeof ApplyBilateralTradeCsvResponseSchema;
  },
  /**
   * ExportBilateralTrades は入稿済みの相対取引契約を CSV 行 (1 行 = 1 leg) と
   * して全量返す (uploads/common.md §6 AC-DUC-028/029)。絞り込みは持たない。
   * Mirrors internalapi.v1 ExportBilateralTrades。
   *
   * @generated from rpc bffuser.v1.SupplyBilateralTradeService.ExportBilateralTrades
   */
  exportBilateralTrades: {
    methodKind: "unary";
    input: typeof ExportBilateralTradesRequestSchema;
    output: typeof ExportBilateralTradesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_supply_bilateral_trade_service, 0);

